import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ionload-leave',
  templateUrl: './ionload-leave.component.html',
  styleUrls: ['./ionload-leave.component.css']
})
export class IonloadLeaveComponent implements OnInit {
  code1:string = `ionViewDidLoad(){ <br> &nbsp; <br> }`;
  code2:string = `ionViewDidEnter(){ <br> &nbsp; <br> }`;
  code3:string = `ionViewDidLeave(){ <br> &nbsp; <br> }`;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Consejos/ionload-leave/ionload-leave.component.ts